import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { useEngagements } from '../../hooks/useEngagements';
import { EngagementList } from '../../components/engagements/EngagementList';
import LoadingPage from '../../components/ui/LoadingPage';
import AddEngagementPopup from '../../components/engagements/AddEngagementPopup';
import EditEngagementPopup from '../../components/engagements/EditEngagementPopup';
import type { Engagement } from '../../types/engagement';

export default function EngagementListPage() {
  const { engagements, loading, error, refetch } = useEngagements();
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [editEngagement, setEditEngagement] = useState<Engagement | null>(null);

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="p-4 text-red-700 bg-red-100 rounded-md">
        Error loading engagements: {error}
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">Engagements</h1>
        <button
          onClick={() => setShowAddPopup(true)}
          className="btn btn-primary inline-flex items-center"
        >
          <Plus className="w-5 h-5 mr-2" />
          Add Engagement
        </button>
      </div>

      <EngagementList 
        engagements={engagements} 
        onEdit={setEditEngagement}
      />

      {showAddPopup && (
        <AddEngagementPopup
          onClose={() => setShowAddPopup(false)}
          onSuccess={async () => {
            await refetch();
            setShowAddPopup(false);
          }}
        />
      )}

      {editEngagement && (
        <EditEngagementPopup
          engagement={editEngagement}
          onClose={() => setEditEngagement(null)}
          onSuccess={async () => {
            await refetch();
            setEditEngagement(null);
          }}
        />
      )}
    </div>
  );
}
